import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';
import Storages from 'storages';
import StorageKeys from 'enum/storages.enum';

function getDeviceProxyServer(deviceId) {
  let url = ApiUrl.proxy_server;

  // Get organization_id from stored license data
  const licenseData = Storages.MainStorage.getItem(StorageKeys.Keys.LICENSEAPIKEY);
  const organization_id = licenseData?.organization_id;

  // Use serial_number and organization_id as per Android API
  const queryParams = {
    serial_number: deviceId,
    organization_id: organization_id,
  };

  for (const paramsKey in queryParams) {
    if (queryParams[paramsKey]) {
      url += url.includes('?') ? '&' : '?';
      url += `${paramsKey}=${queryParams[paramsKey]}`;
    }
  }
  return httpService.get(url);
}

const obj = { getDeviceProxyServer };

export default obj;
